import 'debug';
import { e as entryMixin } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

//
var script = {
  mixins: [entryMixin],
  mounted: function mounted() {
    this.$el.addEventListener('touchmove', function (event) {
      event.handled = true;
      /* Is handled by default scroll behavior of browser */
    }, false);
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "js-entry o-entry c-menu-entry",
      attrs: { role: "navigation" }
    },
    [
      _c(
        "ul",
        { staticClass: "c-menu-entry" },
        _vm._l(this.entryData.MenuItems, function(item) {
          return _c(
            "router-link",
            {
              key: item.id,
              staticClass: "c-menu-entry__item",
              attrs: { tag: "li", to: "/page/" + item.ID }
            },
            [_vm._v("\n            " + _vm._s(item.Title) + "\n        ")]
          )
        }),
        1
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
